/**
 * Détection de la marque (tenant) via le domaine
 * Fallback utilisé tant que les infos entreprise (API /api/enterprise/public)
 * ne sont pas chargées ou pas configurées.
 */

export interface BrandInfo {
  /** Nom affiché de la marque */
  name: string;
  /** Suffixe affiché à côté du nom dans le logo texte ('.mg' pour E-Store, '' sinon) */
  suffix: string;
}

const DEFAULT_BRAND: BrandInfo = { name: 'E-Store', suffix: '.mg' };

const DOMAIN_BRANDS: Array<{ pattern: RegExp; brand: BrandInfo }> = [
  { pattern: /mpiandry-tsara/i, brand: { name: 'Mpiandry Tsara', suffix: '' } },
  { pattern: /laminfo\.|lami-fac\./i, brand: { name: 'LAMI', suffix: '' } },
];

/**
 * Retourne la marque correspondant au domaine courant.
 * @param hostname - permet l'injection pour les tests (défaut: window.location.hostname)
 */
export function getBrandInfo(
  hostname: string = typeof window !== 'undefined' ? window.location.hostname : ''
): BrandInfo {
  return DOMAIN_BRANDS.find(({ pattern }) => pattern.test(hostname))?.brand ?? DEFAULT_BRAND;
}
